export default __webpack_public_path__ + "static/media/trophy.16e6df06.png";